var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "account-manage-companies" },
    [
      !_vm.loaded
        ? _c(
            "div",
            { staticClass: "layout-column flex-center loader" },
            [
              _c("rbv-loading", {
                attrs: { label: "Loading, please wait..." },
              }),
            ],
            1
          )
        : [
            _c("div", { staticClass: "header flex column" }, [
              _c("div", { staticClass: "flex row" }, [
                _c("div", { staticClass: "logo" }, [
                  _vm.account && _vm.account.logo
                    ? _c("img", {
                        attrs: { src: _vm.logo, alt: "Account Logo" },
                      })
                    : _c("div", [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("business"),
                        ]),
                      ]),
                ]),
                _c("div", { staticClass: "flex column" }, [
                  _c("div", { staticClass: "title" }, [
                    _vm._v(" " + _vm._s(_vm.account && _vm.account.name) + " "),
                  ]),
                  _c("div", { staticClass: "sub-title" }, [
                    _vm._v(" " + _vm._s(_vm.module.title) + " "),
                  ]),
                ]),
              ]),
              _c(
                "div",
                { staticClass: "flex row controls" },
                [
                  _c("div", { staticClass: "flex row" }, [
                    _c(
                      "button",
                      { staticClass: "button", on: { click: _vm.editLogo } },
                      [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("add_a_photo"),
                        ]),
                        _vm._v(" Change Logo "),
                      ]
                    ),
                  ]),
                  _vm.isFromRfpManager
                    ? [
                        _c(
                          "button",
                          {
                            staticClass: "button",
                            on: { click: _vm.openRfpManager },
                          },
                          [_vm._v(" RFP Manager ")]
                        ),
                        _c(
                          "button",
                          {
                            staticClass: "button",
                            on: { click: _vm.openManageCustomers },
                          },
                          [_vm._v(" Customers ")]
                        ),
                      ]
                    : _vm._e(),
                  _c(
                    "button",
                    { staticClass: "button", on: { click: _vm.editProfile } },
                    [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("edit"),
                      ]),
                      _vm._v(" Edit Basic Information "),
                    ]
                  ),
                ],
                2
              ),
            ]),
            _c("account-details", { attrs: { entity: _vm.account } }),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }